import { useToast } from '@chakra-ui/react'
import { useDeleteReport } from '../hooks/useDeleteReport'
import { useCallback, useEffect } from 'react'
import { ApiErrorKind, apiErrorKindOf } from '../../../services/apiErrors'

export const useReportStaffActions = ({ reportTicket }) => {
  const toast = useToast({
    position: 'bottom-right',
    variant: 'solid',
    isClosable: true,
    duration: 1000,
  })

  const { deleteReport } = useDeleteReport()

  const handleDelete = useCallback(() => {
    if (!reportTicket) return
    deleteReport.mutate(reportTicket.snapshotId ?? reportTicket.id)
  }, [reportTicket, deleteReport])

  useEffect(() => {
    if (deleteReport.isSuccess) {
      toast({
        title: `Report ${reportTicket.id} deleted!`,
        status: 'success',
      })
    }
  }, [deleteReport.isSuccess, reportTicket.id, toast])

  useEffect(() => {
    if (!deleteReport.isError) return
    toast({
      title:
        apiErrorKindOf(deleteReport.error) === ApiErrorKind.Forbidden
          ? 'Only CEM staff can delete reports.'
          : "We couldn't delete that report.",
      status: 'error',
      duration: 6000,
    })
  }, [deleteReport.isError, deleteReport.error, toast])

  return {
    deleteReport,
    actions: [
      {
        id: '2',
        label: 'Delete',
        action: handleDelete,
      },
    ],
  }
}
